module.exports = __webpack_public_path__ + "img/icon-sign.5fdf150d.svg";